/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupTypeCollectionResponseModel } from './LookupTypeCollectionResponseModel';
import {
    LookupTypeCollectionResponseModelFromJSON,
    LookupTypeCollectionResponseModelFromJSONTyped,
    LookupTypeCollectionResponseModelToJSON,
} from './LookupTypeCollectionResponseModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfLookupTypeCollectionResponseModel
 */
export interface ResultOfListOfLookupTypeCollectionResponseModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfLookupTypeCollectionResponseModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfLookupTypeCollectionResponseModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfLookupTypeCollectionResponseModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfLookupTypeCollectionResponseModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfLookupTypeCollectionResponseModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfLookupTypeCollectionResponseModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfLookupTypeCollectionResponseModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<LookupTypeCollectionResponseModel>}
     * @memberof ResultOfListOfLookupTypeCollectionResponseModel
     */
    data?: Array<LookupTypeCollectionResponseModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfLookupTypeCollectionResponseModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfLookupTypeCollectionResponseModel interface.
 */
export function instanceOfResultOfListOfLookupTypeCollectionResponseModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfLookupTypeCollectionResponseModelFromJSON(json: any): ResultOfListOfLookupTypeCollectionResponseModel {
    return ResultOfListOfLookupTypeCollectionResponseModelFromJSONTyped(json, false);
}

export function ResultOfListOfLookupTypeCollectionResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfLookupTypeCollectionResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(LookupTypeCollectionResponseModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfLookupTypeCollectionResponseModelToJSON(value?: ResultOfListOfLookupTypeCollectionResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(LookupTypeCollectionResponseModelToJSON)),
        'Count': value.count,
    };
}

